import FieldInputTypeahead from './FieldInputTypeahead';
export {InputTypeahead} from './FieldInputTypeahead';
export default FieldInputTypeahead;
